import type {
	EstimateSourceType,
	PricingEstimationService,
	PricingEstimationTotal,
	PricingEstimationTypeSource,
} from '../../types';

export const resolveEstimateServiceSourceType = (
	dataSource: PricingEstimationTypeSource | undefined,
): PricingEstimationTypeSource => {
	return dataSource ?? null;
};

export const resolveEstimateSourceType = (
	estimate: PricingEstimationTotal,
	selectedServices: PricingEstimationService[],
): EstimateSourceType => {
	const selectedSources = selectedServices
		.map((service) => estimate[service]?.dataSource ?? null)
		.filter(
			(source): source is Exclude<PricingEstimationTypeSource, null> =>
				source != null,
		);

	if (selectedSources.length === 0) return 'mix';
	if (selectedSources.every((source) => source === 'VENDOR')) return 'vendor';
	if (selectedSources.every((source) => source !== 'VENDOR')) return 'market';
	return 'mix';
};
